import { call, put, takeEvery, select } from 'redux-saga/effects';
import { message } from 'antd';
import { createPurchasingLead } from '../../requests/create_lead_request';
import { createLeadSuccess, createLeadFailure } from '../actions/create_lead.actions';
import { CREATE_LEAD_REQUEST } from '../constants/create_lead.constants';
import { history } from '../../../../../config/history';

function* createLeadRequest({ params }) {
    const { Leads: { Lead_create: { bike_info_by_vrm } } } = yield select();

    const data = {
        ...params,
        chassisNumber: bike_info_by_vrm.chassisNumber,
        make: bike_info_by_vrm.make,
        model: bike_info_by_vrm.model,
    };
    const created_lead = yield call(createPurchasingLead, data);

    if (created_lead.result) {
        yield put(createLeadSuccess(created_lead.options));
        message.success('New lead successfully created');
        history.push(`/Leads/Lead_profile/${created_lead.options._id}`);
    } else {
        yield put(createLeadFailure(created_lead.error));
        message.error(created_lead.error.message);
    }
}

export default function* createLeadSaga() {
    yield takeEvery(CREATE_LEAD_REQUEST, createLeadRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/create_lead.saga.js